module.exports = __webpack_public_path__ + "static/media/img-01.df707cd8.jpg";